<div class="page-container">
  <!-- Filter Toolbar -->
  <div class="filter-toolbar">
    <mat-form-field floatLabel="always" appearance="outline" class="filter-input">
      <mat-label>Order Number</mat-label>
      <input
        id="orderNumber"
        placeholder="Enter Order Number"
        autocomplete="off"
        matInput
        [(ngModel)]="orderNumber"
        name="orderNumber"
      />
    </mat-form-field>

    <mat-form-field floatLabel="always" appearance="outline" class="filter-input">
      <mat-label>Structure Number</mat-label>
      <input
        id="structureNumber"
        placeholder="Enter Structure Number"
        autocomplete="off"
        matInput
        [(ngModel)]="structureNumber"
        name="structureNumber"
      />
    </mat-form-field>

    <mat-form-field floatLabel="always" appearance="outline" class="filter-input">
      <mat-label>Time Range</mat-label>
      <mat-select
        id="timeRange"
        [(ngModel)]="timeRange"
        (selectionChange)="onTimeRangeChange($event.value)"
        name="timeRange"
      >
        <mat-option value="none">All</mat-option>
        <mat-option *ngFor="let option of timeRangeOptions" [value]="option.value">
          {{ option.label }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-button-toggle-group
      [(ngModel)]="selectedUserOption"
      (change)="onUserToggleChange($event)"
      class="user-toggle"
    >
      <mat-button-toggle value="Current User">Current User</mat-button-toggle>
      <mat-button-toggle value="All Users">All Users</mat-button-toggle>
    </mat-button-toggle-group>

    <div class="filter-actions">
      <button
        mat-stroked-button
        class="clear-btn"
        [disabled]="disableButtons()"
        (click)="clearFields()"
      >
        <mat-icon>close</mat-icon>
        Clear All
      </button>
      <button
        mat-raised-button
        color="primary"
        class="search-btn"
        (click)="getOrderDetails()"
        [disabled]="disableButtons()"
      >
        <mat-icon>search</mat-icon>
        Search
      </button>
    </div>
  </div>

  <!-- Table Container -->
  <div class="container">
    <table
      mat-table
      [dataSource]="dataSource"
      multiTemplateDataRows
      class="mat-elevation-z8"
      *ngIf="dataSource && dataSource.data.length > 0"
    >
      <!-- Column Definitions Start -->
      <!-- Add The Expand Column -->
      <ng-container matColumnDef="expand">
        <th mat-header-cell *matHeaderCellDef aria-label="row actions">&nbsp;</th>
        <td mat-cell *matCellDef="let element">
          <button
            mat-icon-button
            aria-label="expand row"
            (click)="expandedElement = expandedElement === element ? null : element; $event.stopPropagation()"
          >
            <mat-icon *ngIf="expandedElement !== element">keyboard_arrow_down</mat-icon>
            <mat-icon *ngIf="expandedElement === element">keyboard_arrow_up</mat-icon>
          </button>
        </td>
      </ng-container>

      <!-- Add The OrderId Column -->
      <ng-container matColumnDef="orderId">
        <th mat-header-cell *matHeaderCellDef>OrderId</th>
        <td mat-cell *matCellDef="let element">{{ element.orderId }}</td>
      </ng-container>

      <!-- Add The OrderNumber Column -->
      <ng-container matColumnDef="orderNumber">
        <th mat-header-cell *matHeaderCellDef>OrderNumber</th>
        <td mat-cell *matCellDef="let element">{{ element.orderNumber }}</td>
      </ng-container>

      <!-- Add The StructureNumber Column -->
      <ng-container matColumnDef="structureNumber">
        <th mat-header-cell *matHeaderCellDef>StructureNumber</th>
        <td mat-cell *matCellDef="let element">{{ element.structureNumber }}</td>
      </ng-container>

      <!-- Add The Restricted Product Column -->
      <ng-container matColumnDef="isRestricted">
        <th mat-header-cell *matHeaderCellDef>Restricted Product</th>
        <td mat-cell *matCellDef="let element">{{ element.isRestricted ? 'Yes' : 'No' }}</td>
      </ng-container>

      <!-- Add The UserName Column -->
      <ng-container matColumnDef="userName">
        <th mat-header-cell *matHeaderCellDef>UserName</th>
        <td mat-cell *matCellDef="let element">{{ element.userName }}</td>
      </ng-container>

      <!-- Add The CreatedDate Column -->
      <ng-container matColumnDef="createdDate">
        <th mat-header-cell *matHeaderCellDef>CreatedDate</th>
        <td mat-cell *matCellDef="let element">{{ element.createdDate }}</td>
      </ng-container>

      <!-- Add The Inbound Column -->
      <ng-container matColumnDef="inbound">
        <th mat-header-cell *matHeaderCellDef>Inbound</th>
        <td mat-cell *matCellDef="let element">
          <button mat-icon-button (click)="copyFileName(element.inboundFileName); $event.stopPropagation()">
            <mat-icon>content_copy</mat-icon>
          </button>
        </td>
      </ng-container>

      <!-- Add The Outbound Column -->
      <ng-container matColumnDef="outbound">
        <th mat-header-cell *matHeaderCellDef>Outbound</th>
        <td mat-cell *matCellDef="let element">
          <ng-container *ngIf="element.outboundFileName; else noOutbound">
            <button mat-icon-button (click)="copyFileName(element.outboundFileName); $event.stopPropagation()">
              <mat-icon>content_copy</mat-icon>
            </button>
          </ng-container>
          <ng-template #noOutbound>
            <span>Not Available</span>
          </ng-template>
        </td>
      </ng-container>

      <!-- Add The RequestId Column (hidden) -->
      <ng-container matColumnDef="requestId">
        <th mat-header-cell *matHeaderCellDef class="hidden-column">RequestId</th>
        <td mat-cell *matCellDef="let element" class="hidden-column">{{ element.requestId }}</td>
      </ng-container>

      <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
      <ng-container matColumnDef="expandedDetail">
        <td mat-cell *matCellDef="let element" [attr.colspan]="columnsToDisplayWithExpand.length">
          <div class="element-detail" [@detailExpand]="element === expandedElement ? 'expanded' : 'collapsed'">
            <!-- Expanded Content -->
            <div class="expanded-content" [@.disabled]="true">
              <mat-tab-group style="width: 100%" (selectedTabChange)="onTabChange($event, element)">
                <mat-tab label="KeyCom">
                  <!-- KeyCom Tab Content -->
                  <div class="tab-content">
                    <p>{{ element.statusDescription }}</p>
                  </div>
                </mat-tab>
                <mat-tab label="Order Entry">
                  <!-- Order Entry Tab Content -->
                  <div class="tab-content">
                    <p>{{ oeStatus }}</p>
                  </div>
                </mat-tab>
                <mat-tab label="Restricted Product" *ngIf="element.isRestricted">
                  <!-- Restricted Product Tab Content -->
                  <div class="tab-content">
                    <p>{{ rpStatus }}</p>
                  </div>
                </mat-tab>
              </mat-tab-group>
            </div>
          </div>
        </td>
      </ng-container>

      <!-- Row Definitions -->
      <tr mat-header-row *matHeaderRowDef="columnsToDisplayWithExpand"></tr>
      <tr
        mat-row
        *matRowDef="let element; columns: columnsToDisplayWithExpand"
        class="element-row"
        [class.expanded-row]="expandedElement === element"
        (click)="expandedElement = expandedElement === element ? null : element"
      ></tr>
      <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row"></tr>
    </table>

    <!-- Add paginator after the table -->
    <mat-paginator
      *ngIf="showPaginator"
      class="paginator-wrapper"
      [length]="dataSource.data.length"
      [pageSize]="pageSize"
      [pageSizeOptions]="pageSizeOptions"
      (page)="pageChanged($event)"
      showFirstLastButtons
    ></mat-paginator>

    <!-- No Data message -->
    <div *ngIf="showNoData" class="no-data-message">No data available</div>
  </div>
</div>
